import { APIClient } from "./APIClient";
import { Logger } from "../logger/logger";
import { Services } from "./services";
import { GetScout, DiscoverReqCtx } from "../types/discover/getScout";
import { GetCastAndCrew } from "../types/discover/getCastAndCrew";
import { constructRequest, OperationType } from "./request";

export enum Operation {
    GetScout = 'GetScout',
    GetCastAndCrew = 'GetCastAndCrew'
}

export class DiscoverClient {
    api: APIClient;
    logger: Logger;
    endpoint?: string;
    constructor(api = new APIClient()) {
        this.api = api;
        this.logger = api.logger;
        if (api.endpoints != null && api.endpoints.serviceEndpoints != null) {
            this.endpoint = api.endpoints.serviceEndpoints[Services.ATVDiscoverService]
        }
    }

    call = async <Req extends DiscoverReqCtx & { logger?: Logger }, Res>(operation: Operation, body: Req, operationType: OperationType) => {
        if (global.__SERVER__) {
            const req = constructRequest(this.logger, body.requestContext.requestID, this.endpoint, body, {
                name: `${Services.ATVDiscoverService} ${operation}`,
                requester: 'DiscoverClient',
                operationType,
                headers: { 'x-amz-target': `com.amazon.ATVWebDiscover.ATVWebDiscoverService.${operation}` }
            });
            return await this.api.call(...req) as Res;
        } else {
            const req = constructRequest(this.logger, body.requestContext.requestID, '/gp/video/discoverapi', body, {
                name: `${Services.ATVDiscoverService} ${operation}`,
                requester: 'DiscoverClient',
                operationType
            })
            return await this.api.call(...req) as Res;
        }
    }

    async GetScout(body: GetScout.ServersideRequest) {
        const requestBody = global.__SERVER__
            ? {
                ScoutTitleInputList: body.ScoutTitleInputList,
                ScoutCategoryList: [],
                ScoutEntityType: body.ScoutEntityType,
                requestContext: body.requestContext
            } as GetScout.ServersideRequest
            : {
                titleInputList: body.ScoutTitleInputList.join(','),
                entityType: body.ScoutEntityType,
                requestContext: body.requestContext
            } as GetScout.ClientsideRequest
        return await this.call<GetScout.ServersideRequest | GetScout.ClientsideRequest, GetScout.Response>(Operation.GetScout, requestBody, OperationType.READ);
    }

    async GetCastAndCrew(body: GetCastAndCrew.ServersideRequest) {
        const requestBody = {
            titleId: body.titleId,
            requestContext: body.requestContext,
        } as GetCastAndCrew.ServersideRequest
        return await this.call<GetCastAndCrew.ServersideRequest, GetCastAndCrew.Response>(Operation.GetCastAndCrew, requestBody, OperationType.READ)
    }

}
